module.exports = __webpack_public_path__ + "static/media/folder.cc1deb83.svg";